export { default } from './Search';
export type { Props, Props as FiltersSearchProps } from './Search';
